import React from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import AuthPanel from './AuthPanel';

function RequireAdmin() {
  const location = useLocation();
  const { isAdmin, status } = useAuth();

  if (status === 'bootstrapping') {
    return (
      <AuthPanel
        eyebrow="Admin"
        title="Checking your access"
        description="We are verifying your administrator session before opening invite tools."
      >
        <p className="auth-panel-meta mb-0">This should only take a moment.</p>
      </AuthPanel>
    );
  }

  if (status !== 'authenticated') {
    return (
      <Navigate
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
          authMessage: 'Please log in to continue.',
        }}
        to="/login"
      />
    );
  }

  if (!isAdmin) {
    return (
      <AuthPanel
        eyebrow="Admin"
        title="Administrator access only"
        description="This invite screen is reserved for administrator accounts."
      >
        <div className="auth-panel-inline-actions auth-panel-stack">
          <Link className="btn auth-panel-secondary" to="/">
            Back to events
          </Link>
        </div>
      </AuthPanel>
    );
  }

  return <Outlet />;
}

export default RequireAdmin;
